/* eslint-disable jsx-a11y/control-has-associated-label */
export default function TableHeader({ children, ...rest }) {
  if (children.length > 0) {
    return (
      <th className="p-3" {...rest}>
        {children}
      </th>
    );
  }
  return <th className="border-opacity-0" />;
}
